















import Vue from 'vue';
import { RouteRegEx, Dictionary, Workflow, WorkflowQueueDataModel, TableFilterModel } from '@/types';
import { WorkflowQueueService } from '@/services/WorkflowQueueService';
import DefaultWorkflowQueue from '@/components/workflow/DefaultWorkflowQueue.vue';
import OpenDocumentsToStoreAndJobsWorkflowQueue from '@/components/workflow/OpenDocumentsToStoreAndJobsWorkflowQueue.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import BulkEmailWorkflowQueue from '@/components/workflow/BulkEmailWorkflowQueue.vue';
import DocuSignWorkflowQueue from '@/components/workflow/docuSign/DocuSignWorkflowQueue.vue';
import ScriveWorkflowQueue from '@/components/workflow/scrive/ScriveWorkflowQueue.vue';
import WorkflowKanbanQueue from '@/components/workflow/kanban/WorkflowKanbanQueue.vue';
import { mapActions, mapGetters } from 'vuex';
import WorkflowArchiveQueue from '@/components/workflow/WorkflowArchiveQueue.vue';
import { Components } from '@/customer';

export default Vue.extend({
  name: 'WorkflowQueue',
  data() {
    return {
      workflowQueueDataModel: {} as WorkflowQueueDataModel,
      isLoading: false,
      pageIsLoading: false
    };
  },
  computed: {
    ...mapGetters('workflowQueueStore', ['getArchiveQueueFilters']),
    ...mapGetters('userPreferencesStore', ['retainFilterOptions'])
  },
  methods: {
    ...mapActions('workflowQueueStore', ['resetWorkflowQueueState']),
    ...mapActions('userPreferencesStore', ['setFilterOptions', 'setRetainFilterOptions']),
    async getWorkflowQueueAsync(id: number) {
      try {
        this.isLoading = true;
        this.workflowQueueDataModel = await WorkflowQueueService.getWorkflowQueueAsync(id, this.getArchiveQueueFilters.filterDictionary);
      } catch (error) {
        this.$log(`Error getting work flow queue ${error}`);
      } finally {
        this.isLoading = false;
      }
    },
    getWorkflowJob(jobId: number) {
      if (this.workflowQueueDataModel.canOpenJobs) {
        this.$router.push({
          name: 'WorkflowJob',
          params: {
            queueId: this.workflowQueueDataModel.queueId.toString(),
            jobId: jobId.toString()
          }
        });
      }
    },
    openWorkflowJobInNewTab(jobId: number) {
      if (this.workflowQueueDataModel.canOpenJobs) {
        const routeData = this.$router.resolve({
          name: Workflow.JobTab.name,
          params: {
            queueId: this.workflowQueueDataModel.queueId.toString(),
            jobId: jobId.toString()
          }
        });
        window.open(routeData.href, '_blank')?.focus();
      }
    },
    clearQueueFilters(queueId: string) {
      const userRetatinFilterOptions: boolean = this.retainFilterOptions(queueId);
      if (!userRetatinFilterOptions) {
        this.setFilterOptions({ queueId, filterOptions: [] });
      }
    }
  },
  async mounted() {
    this.pageIsLoading = true;
    await this.getWorkflowQueueAsync(parseInt(this.$route.params.id, 10));
    this.pageIsLoading = false;
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== Workflow.Job.name) {
      this.resetWorkflowQueueState();
      this.clearQueueFilters(from.params.id);
    }

    next();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name !== Workflow.Job.name) {
      this.clearQueueFilters(from.params.id);
    }

    next();
  },
  components: {
    DefaultWorkflowQueue,
    LoadingSpinner,
    BulkEmailWorkflowQueue,
    DocuSignWorkflowQueue,
    ScriveWorkflowQueue,
    WorkflowKanbanQueue,
    WorkflowArchiveQueue,
    OpenDocumentsToStoreAndJobsWorkflowQueue,
    ...Components.WorkflowQueue
  }
});
